export const buildImageUrl = endpoint => {
	if (process.env.NODE_ENV === 'development')
		return `${process.env.VUE_APP_BASE_IMAGE_URL}${endpoint}`;
	else return `${endpoint}`;
}
